import { DefaultRouteTabs } from '@/components/_common';
import WorkOrderChecklistObservationModal from '@/components/Movements/WorkOrders/Details/Observations/ObservationChecklistModal';
import WorkorderChecklistFooter from '@/components/Movements/WorkOrders/WorkorderChecklist/ChecklistFooter';
import { useWorkorderChecklistContext } from '@/components/Movements/WorkOrders/WorkorderChecklist/WorkorderChecklistProvider';
import {
  useChecklistObservation,
  useCheckListObservationRemove,
} from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.hooks';
import { ChecklistObservationListResponse } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { WorkOrderObservationVisibility } from '@/core/domain/workorder/WorkOrdersObservations/WorkOrdersObservations.types';
import { useDisclosure } from '@/hooks';
import useChecklistValidRoutes from '@/hooks/useChecklistValidRoutes';
import { PageProps } from '@/types/PageProps';
import {
  Button,
  Card,
  Empty,
  Modal,
  Skeleton,
  Space,
  Timeline,
  Typography,
} from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';

export default function ChecklistObservationsPage({ route }: PageProps) {
  const {
    checklistItemId,
    checklistItemType,
    diagnosticId,
    boschChecklist,
    workorderComplementId,
    workorderId,
  } = useWorkorderChecklistContext();

  const observationList = useChecklistObservation({
    diagnosticId: diagnosticId,
    workOrderComplementId: workorderComplementId,
    visibility: WorkOrderObservationVisibility.All,
  });
  const removeObservation = useCheckListObservationRemove();

  const [observationSelected, setObservationSelected] =
    useState<ChecklistObservationListResponse>();
  const [modalVisible, modalAction] = useDisclosure(false, {
    onClose() {
      setObservationSelected(undefined);
    },
  });

  const routeParent = useChecklistValidRoutes({
    route,
    checklistItemType,
    workorderId,
    boschChecklist,
  });

  function removeConfirm(observationId: number) {
    Modal.confirm({
      title: 'Remover observação',
      content: 'Deseja realmente remover a observação selecionada?',
      okText: 'Remover',
      onOk: () => removeObservation.mutateAsync(observationId),
    });
  }

  return (
    <DefaultRouteTabs
      route={routeParent}
      baseKey={String(checklistItemId)}
      basePath={`/app/movements/workorderChecklist/${checklistItemId}`}
      extra={
        <Button block type="primary" onClick={modalAction.open}>
          Adicionar observação
        </Button>
      }
    >
      <Skeleton active loading={false}>
        <Timeline
          style={{ maxHeight: '314px', overflowY: 'auto', paddingTop: '12px' }}
        >
          {observationList.data?.map((item) => (
            <Timeline.Item key={item.id}>
              <Typography.Title level={4} style={{ marginBottom: 0 }}>
                {item.observation}
              </Typography.Title>

              <Space align="center">
                <Typography.Paragraph
                  type="secondary"
                  style={{ marginBottom: 0 }}
                >
                  <Typography.Text style={{ fontSize: '12px' }}>
                    {item.employeeName} -{' '}
                    {moment(item.createdAt).format('DD/MM/YYYY HH:mm')}
                  </Typography.Text>
                </Typography.Paragraph>
                <Button
                  size="small"
                  type="text"
                  icon={<FaEdit />}
                  onClick={() => {
                    setObservationSelected(item);
                    modalAction.open();
                  }}
                />
                <Button
                  size="small"
                  danger
                  type="text"
                  icon={<FaTrash />}
                  onClick={() => removeConfirm(item.id)}
                />
              </Space>
            </Timeline.Item>
          ))}

          {!observationList.data?.length && (
            <Card>
              <Empty description="Este checklist ainda não tem observações">
                <Button onClick={modalAction.open}>Adicionar observação</Button>
              </Empty>
            </Card>
          )}
        </Timeline>
      </Skeleton>

      <WorkorderChecklistFooter />

      <WorkOrderChecklistObservationModal
        open={modalVisible}
        onCancel={modalAction.close}
        observation={observationSelected}
      />
    </DefaultRouteTabs>
  );
}
